// Mobile "ben" endpoint'leri — giris yapmis musterinin kendi verilerine erisim.
// Tum endpoint'ler MusteriJwt korumali (musteri-kimlik).
import { z } from 'zod';
// === Cuzdan hareketleri ===
export const cuzdanHareketTipi = z.enum([
    'YUKLEME',
    'KIRALAMA',
    'IADE',
    'PROMOSYON',
    'CEZA',
    'DUZELTME',
]);
export const cuzdanHareketSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
});
// Anasayfa/kiralama listesi "aktif" filtresi — backend ile aynı kabul edilir.
// KRITIK: ODEME_BEKLIYOR ve OLUSTURULDU listeden CIKARILDI — para tahsil edilmemis
// kiralamalar kullaniciya "aktif" gibi gosterilmemeli. Bunlar pending statu —
// odeme tamamlanir/iptal/timeout cron'u ile temizlenir.
export const AKTIF_KIRALAMA_DURUMLAR = [
    'AKTIF',
    'DOLAP_ACILDI',
    'KULLANILIYOR',
    'TESLIM_ALINIYOR',
    'SORUNLU',
    'SURESI_GECTI',
];
// Backend musteri-ben.servis "aktif kiralamasi var mi" check'i icin GENIS liste
// (odeme bekleyen kayitlari da sayar; ayni anda iki kart cekimi denemesin).
export const KISITLAYICI_AKTIF_DURUMLAR = [
    'OLUSTURULDU',
    'ODEME_BEKLIYOR',
    ...[
        'AKTIF',
        'DOLAP_ACILDI',
        'KULLANILIYOR',
        'TESLIM_ALINIYOR',
        'SORUNLU',
        'SURESI_GECTI',
    ],
];
export const kiralamaBenSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    aktifMi: z.coerce.boolean().optional(),
});
// === Profil guncelleme (kendi musteri'sini guncelle) ===
// Cinsiyet enum'i musteri.ts'de zaten tanimli — burada tekrar export etme.
export const musteriBenGuncelle = z
    .object({
    adSoyad: z.string().min(3).max(120).optional(),
    // ISO date string (YYYY-MM-DD); null = sil, undefined = degistirme
    dogumTarihi: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable()
        .optional(),
    cinsiyet: z.enum(['ERKEK', 'KADIN', 'BELIRTILMEMIS']).optional(),
    // null = sil, '' de null'a esitlenir, undefined = degistirme
    eposta: z.union([z.string().email().max(200), z.literal(''), z.null()]).optional(),
})
    // O8 fix: bos govde (`{}`) anlamli degil — en az bir alan gerekli
    .refine((d) => Object.values(d).some((v) => v !== undefined), {
    message: 'En az bir alan gerekli',
});
// === Destek talebi (mobile musteri tarafindan olustur) ===
export const destekTalepIstegi = z.object({
    konu: z.string().min(3).max(200),
    aciklama: z.string().min(10).max(4000),
    kategori: z.enum(['ode', 'dolap', 'rez', 'hesap', 'diger']).optional(),
});
// === Anlik kiralama olustur ===
export const kiralamaOlusturIstegi = z.object({
    dolapId: z.string().min(5),
    sureSaat: z.coerce.number().int().min(1).max(168), // max 7 gun
    /** Odeme yontemi: cuzdan (bakiye yeterse) veya akbank 3DS */
    odemeYontemi: z.enum(['CUZDAN', 'KART']),
});
//# sourceMappingURL=ben.js.map